module.exports = "// Wrong:\nfunction rowRenderer ({ key, index, style }) {\n  return (\n    <div key={key}>\n      {items[index]}\n    </div>\n  )\n}\n\n// Right:\nfunction rowRenderer ({ key, index, style }) {\n  return (\n    <div\n      key={key}\n      style={style}\n    >\n      {items[index]}\n    </div>\n  )\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/forgotten-styles.js
 ** module id = 280
 ** module chunks = 0
 **/